import jexcel, { fromSpreadsheet } from 'jexcel';
import jsuites from 'jsuites';
import axios from 'axios';


$(document).ready(() => {
    $('#info-data-sent').modal('show');
    $('#multiple_shipping_addresses').change(() => {
        $("#addresses-information").toggle()
    });

    if (!Array.prototype.includes) {
        Array.prototype.includes = function(searchElement /*, fromIndex*/) {
          'use strict';
          if (this == null) {
            throw new TypeError('Array.prototype.includes called on null or undefined');
          }
      
          var O = Object(this);
          var len = parseInt(O.length, 10) || 0;
          if (len === 0) {
            return false;
          }
          var n = parseInt(arguments[1], 10) || 0;
          var k;
          if (n >= 0) {
            k = n;
          } else {
            k = len + n;
            if (k < 0) {k = 0;}
          }
          var currentElement;
          while (k < len) {
            currentElement = O[k];
            if (searchElement === currentElement ||
               (searchElement !== searchElement && currentElement !== currentElement)) { // NaN !== NaN
              return true;
            }
            k++;
          }
          return false;
        };
      }

    if (typeof window.bennatisync != "undefined" 
        && window.bennatisync.cart.addresses.length
    ) {
        window.location.replace("/account");
    } else {
        $('#order-addresses').show();
    }

    if ($('#order-addresses').length) {
        /* const data = [
            ['5', 'Blabla', 'Bloblo', 'sgfsgr', 'Via Milano 1', '', '', '20133', 'Milano', 'Mi', '0123456789', 'It', 'a@a.com', 'Nome confezione', 'codice confezione'],
        ]; */
        const customer = window.prestashop.customer;
        /* const biaug = window.bennatisync.products.find(product => ["330"].includes(product.reference));
        console.log(biaug);
        if(typeof biaug == 'undefined') {
            $('#biaug-form').css("display", "none");
        } else {
            $('#biaug-form').css("display", "block");
        } */
        const generateAddressRow = (rows, product) => {
            for (let i = 0; i < product.product_quantity; i++) {
              if(!["330"].includes(product.reference)) {
                  rows.push([
                      product.product_name,
                      product.reference,
                      customer.company || `${customer.firstname} ${customer.lastname}`,
                      '',
                      '',
                      '',
                      '',
                      '',
                      '',
                      '',
                      '',
                      '',
                      'IT',
                      '',
                      product.real_weight,
                      (typeof window.bennatisync.order !== 'undefined') ? window.bennatisync.order.id : '-',
                      (typeof window.bennatisync.order !== 'undefined') ? window.bennatisync.order.reference : '-',
                  ])
              }
            }
            return rows; 
        }
        const initial_data = window.bennatisync.products.reduce(generateAddressRow, []);
        // console.log(window.bennatisync.products);
        // console.log(initial_data);
        const data = window.bennatisync.cart.addresses.length  ? JSON.parse(window.bennatisync.cart.addresses) : initial_data;
        
        $('#wrapper').css({'max-width': '90%'});
        const wrapperWidth = $('#wrapper').width();
        const colWidth = wrapperWidth / 15;

        const countries = Object.keys(window.bennatisync.countries)
            .reduce((data, val) => {
            return [window.bennatisync.countries[val]['iso_code'], ...data];
        }, [])
            .sort();

        const addressesTable = jexcel(document.getElementById('order-addresses'), {
            data:data,
            columns:[
              { title:'Nome confezione', width: colWidth, readOnly: true },
              { title:'Codice confezione', width: colWidth, readOnly: true },
              { title:'Ragione sociale mittente', width: colWidth },
              { title:'Ragione sociale o nome destinatario', width: colWidth },
              { title:'All’attenzione di', width: colWidth },
              { title:'Indirizzo 1 via e numero civico', width: colWidth },
              { title:'Indirizzo 2 interno, scala, numero citofono', width: colWidth },
              { title:'Indirizzo 3 località, quartiere', width: colWidth },
              { title:'Cap', width: colWidth },
              { title:'Città', width: colWidth },
              { title:'Provincia', width: colWidth },
              { title:'Telefono destinatario', width: colWidth },
              { title:'Stato (es: it)', type: 'dropdown', source: countries, width: colWidth },
              { title:'Email destinatario', width: colWidth },
              { title:'PESO TOTALE', width: colWidth, readOnly: true, type: 'hidden' },
              { title:'ORDER_ID', width: colWidth, readOnly: true, type: 'hidden' },
              { title:'ORDER_REFERENCE', width: colWidth, readOnly: true, type: 'hidden' },
            ],
            onbeforeinsertcolumn: () => false,
            onbeforedeletecolumn: () => false,
            contextMenu: () => false,
            oncreateeditor: (el, cell, x, y, editor) => {
                // recipientProvince
                if (x == 10) {
                    $(editor).keypress((event) => {
                        if ($(editor).val().length > 1) {
                            return false;
                        }
                    });
                    $(editor).keyup((event) => {
                        $(editor).val($(editor).val().toUpperCase());
                    });
                }
            },
            allowInsertRow: false,
            allowManualInsertRow: false,
            allowInsertColumn: false,
            allowManualInsertColumn: false,
            allowDeleteRow: false,
            allowDeletingAllRows: false,
            allowDeleteColumn: false,
            allowRenameColumn: false,
            tableOverflow: true,
        });

        /* $('#addRow').click(function () {
            addressesTable.insertRow();
        }); */

        $('#save-addresses').click(function (e) {
            e.preventDefault();
            const cellChars = {
             '0': 'A',
             '1': 'B',
             '2': 'C',
             '3': 'D',
             '4': 'E',
             '5': 'F',
             '6': 'G',
             '7': 'H',
             '8': 'I',
             '9': 'J',
             '10': 'K',
             '11': 'L',
             '12': 'M',
             '13': 'N',
             '14': 'O',
             '15': 'P',
             '16': 'Q',
            };

            const indexJsonKey = {
              '0': 'prodName',
              '1': 'prodCod',
              '2': 'senderName',
              '3': 'recipientName',
              '4': 'recipientAttentionOf',
              '5': 'recipientAddress1',
              '6': 'recipientAddress2',
              '7': 'recipientAddress3',
              '8': 'recipientZipCode',
              '9': 'recipientCity',
              '10': 'recipientProvince',
              '11': 'recipientTelephone',
              '12': 'recipientCountry',
              '13': 'recipientEmail',
              '14': 'totalWeight',
              '15': 'orderId',
              '16': 'orderReference',
            };

            const validColumn = (col, type, rowIndex, colIndex, required, otherVal) => {
                const showError = (status) => {
                    // console.log(status);
                    if (!status) {
                        console.log(cellChars[colIndex])
                        addressesTable.setStyle(`${cellChars[colIndex]}${rowIndex+1}`, 'background-color', '#ff6b6b')
                    } else {
                        addressesTable.setStyle(`${cellChars[colIndex]}${rowIndex+1}`, 'background-color', 'initial');
                    }
                }
                
                // if not required and empty is valid and skip type validation
                if (!required && col.length === 0) {
                    return true;
                }

                switch (type) {
                    case 'text':
                        showError(col.length > 0);
                        // console.log(col.length > 0)
                        return col.length > 0;
                    case 'number':
                        // console.log(col.match(/^[1-9]+$/));
                        showError(col.match(/^\d+$/));
                        return col.match(/^\d+$/);
                    case 'zipIt':
                        if (otherVal !== 'IT') {
                            showError(col.length > 0);
                            return col.length > 0;
                        }
                        showError(col.match(/^\d{5}$/));
                        return col.match(/^\d{5}$/);
                    case 'email':
                        const valid = col.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                        showError(valid);
                        return valid;
                    default:
                        return false;
                }
            };
            const validRow = (row, rowIndex) => {
                // console.log(validColumn(row[0], 'text', rowIndex, 0), true);
                return validColumn(row[0], 'text', rowIndex, 0, true)
                && validColumn(row[1], 'text', rowIndex, 1, true)
                && validColumn(row[2], 'text', rowIndex, 2, true)
                && validColumn(row[3], 'text', rowIndex, 3, true)
                && validColumn(row[4], 'text', rowIndex, 4, false)
                && validColumn(row[5], 'text', rowIndex, 5, true)
                && validColumn(row[8], 'zipIt', rowIndex, 8, true, row[12])
                && validColumn(row[9], 'text', rowIndex, 9, true)
                && validColumn(row[10], 'text', rowIndex, 10, true)
                && validColumn(row[11], 'text', rowIndex, 11, true)
                && validColumn(row[12], 'text', rowIndex, 12, true)
                && validColumn(row[13], 'email', rowIndex, 13, true);
            };

            const validTable = (table) => {
                return table.reduce((acc, row, rowIndex) => acc && validRow(row, rowIndex), true);
            };

            const saveJson = (rows) => {
                try {
                    $('#loader').show();
                    const url = `/order_addresses/${$('#save-addresses').data('order-id')}?action=saveorderaddresses&token=${window.prestashop.token}`;
                    // console.log(url);
                    const data = rows;
                    /* const card_message = $('#card_message').val();
                    const card_signature = $('#card_signature').val();
                    const query_params = `addresses=${JSON.stringify(data)}&card_message=${card_message}&card_signature=${card_signature}`; */
                    const query_params = `addresses=${JSON.stringify(data)}`;
                    // console.log(JSON.stringify(data));
                    axios.post(url, query_params).then((res) => {
                        // $('#loader').hide();
                        window.location.href = '/account?success_multiple_addresses=1';
                        // console.log(res);
                    });
                } catch (error) {
                    $('#loader').hide();
                    console.log(error.response);
                }
            };

            const buildData = (rows) => {
              let addresses = {};

              // iterate on rows
              rows.forEach((row, index) => {
                let address = {};

                // iterate on columns
                row.forEach((column, index) => {
                  address[indexJsonKey[index]] = column;
                });
                
                addresses[index] = address;              
              });

              return addresses;
            };

            const rows = addressesTable.getData();

            const filterByCode = (code) => (row) => row[14] === code;
            const totalByCode = (total, row) => total + parseInt(row[0]);

            /* const validProductQuantity = (valid, product) => {
                const rowsByCode = rows.filter(filterByCode(product.reference));
                const totalRowsByCode = rowsByCode.reduce(totalByCode, 0);
                // console.log(rowsByCode);
                // console.log(totalRowsByCode);
                return valid && (totalRowsByCode === parseInt(product.product_quantity));
            }
            const validQuantities = window.bennatisync.products.reduce(validProductQuantity, true); */
            // const getQuantitybyProduct = (total, product) => total + product.product_quantity;
            // const validQuantities = window.bennatisync.products.reduce(getQuantitybyProduct, 0);
            
            // if (validTable(rows) && validQuantities) {
            console.log($('#card_signature').val())
            if (validTable(rows)) {
              const addressesJson = buildData(rows);
              saveJson(addressesJson);
            }  
            /* else if (validTable(rows) && !validQuantities) {
                $("#alert-wrong-products-numbers").modal('show');
                // console.log("Products quantities do not match order's");
            }; */
        });
    }

});



// WEBPACK FOOTER //
// ./js/order.js